/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnersListResponseGetRecordsList } from '../../models/partners-list-response-get-records-list';

export interface PartnersControllerGetPartners$Params {

/**
 * Sales organization code, related to the country code.
 */
  salesOrganisation: string;

/**
 * A search string for customers searching - may include partial name,
 *     customer number or other fragment of partner data, like address.
 */
  searchString: string;

/**
 * Whether to include end customers in the search.
 */
  withEndCustomers?: boolean;

/**
 * Language code of the application performing API request.
 */
  'x-ca-application-lang-code'?: 'cs' | 'de' | 'en' | 'es' | 'fr' | 'nl' | 'pl' | 'sk';

/**
 * A header used for security reasons. Header is automatically sent by browsers. When using the code-to-API solution (calling this API directly by script code or other API) please contact <strong>Customer Apps</strong> team for more details.
 */
  referer?: string;

/**
 * Authentication token from Viessmann IAM OAuth2. Required for VIESSMANN_IAM authentication.
 */
  authorization?: string;

/**
 * Application ID identifying the client application. Required for VIESSMANN_IAM authentication.
 */
  'x-application-id'?: 'HEAT_PUMP_PLANNER' | 'PHOTOVOLTAIC_PLANNER' | 'VENTILATION_PLANNER' | 'VIGUIDE_PLANNING' | 'HOME_PLANNER' | 'BOILER_PLANNER' | 'SALESFORCE' | 'CONFIGURATION_PORTAL' | 'AIR_TO_AIR';

/**
 * Country code of the client application instance. Required for VIESSMANN_IAM authentication.
 */
  'x-application-country-code'?: 'AT' | 'BE' | 'CH' | 'CZ' | 'DE' | 'ES' | 'FR' | 'NL' | 'PL' | 'SK' | 'LU';
}

export function partnersControllerGetPartners(http: HttpClient, rootUrl: string, params: PartnersControllerGetPartners$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnersListResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, partnersControllerGetPartners.PATH, 'get');
  if (params) {
    rb.query('salesOrganisation', params.salesOrganisation, {});
    rb.query('searchString', params.searchString, {});
    rb.query('withEndCustomers', params.withEndCustomers, {});
    rb.header('x-ca-application-lang-code', params['x-ca-application-lang-code'], {});
    rb.header('referer', params.referer, {});
    rb.header('authorization', params.authorization, {});
    rb.header('x-application-id', params['x-application-id'], {});
    rb.header('x-application-country-code', params['x-application-country-code'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnersListResponseGetRecordsList>;
    })
  );
}

partnersControllerGetPartners.PATH = '/planning-projects/v1-preview/partners';
